import { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import axiosAdmin from "../../../../api/apiAdmin";
import BlogCardAdmin from "./BlogCardAdmin";
import { successToast, errorToast } from "../../toastAlerts/ToastAlerts";
import {
  MultipleFileInput,
  MultyLangualTextArea,
  MultyLangualTextInput,
  MultyLangualRichText,
  TextInput,
} from "../../inputComponents/inputcomp";
import { FileInput } from "../../inputComponents/inputcomp";

const BlogsAdmin = () => {
  const { t } = useTranslation();
  const [addNewToggler, setAddNewToggler] = useState(false);
  const [newData, setNewData] = useState({});
  const [blogData, setBlogData] = useState([]);
  const [mainInfoData, setMainInfoData] = useState([]);
  const [activeTab, setActiveTab] = useState("other");

  const handleAddNewToggle = (value) => {
    setAddNewToggler(value);
  };

  const handleAddNewData = (value, inputName) => {
    setNewData((prev) => ({ ...prev, [inputName]: value }));
  };

  const handleFetchData = () => {
    axiosAdmin
      .get(`/blog`)
      .then(({ data }) => {
        setBlogData(data.filter((item) => item.type !== "mainInfo"));
        setMainInfoData(data.filter((item) => item.type === "mainInfo"));
      })
      .catch((err) => {});
  };

  const handleDeleteData = (id) => {
    axiosAdmin
      .delete(`/blog/${id}`)
      .then((res) => {
        handleFetchData();
        successToast(t("admin_blog_deleted_success"));
      })
      .catch((err) => {
        errorToast(t("admin_error_try_again"));
      });
  };

  const handleAddNewToDb = (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);

    formData.append("titleGe", newData.titleGe);
    formData.append("titleEn", newData.titleEn);
    formData.append("smalTextGe", newData.smalTextGe);
    formData.append("smalTextEn", newData.smalTextEn);
    formData.append("textGe", newData.textGe);
    formData.append("textEn", newData.textEn);
    formData.append("type", "blog");

    axiosAdmin
      .post(`/blog`, formData)
      .then((res) => {
        handleFetchData();
        successToast(t("admin_blog_added_success"));
      })
      .catch((err) => {
        errorToast(t("admin_error_try_again"));
      });
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  return (
    <div className="xl:ml-[280px] mt-[55px] bg-slate-100 max-md:ml-0 dark:bg-slate-900">
      <div className="w-full pt-10 p-5 flex flex-col gap-5">
        {/* Tabs */}
        <div className="flex gap-2">
          <button
            onClick={() => setActiveTab("other")}
            className={`rounded-lg p-3 text-sm font-bold ${
              activeTab === "other"
                ? "bg-violet-400 text-white"
                : "bg-white text-gray-500 dark:bg-slate-700 dark:text-gray-300"
            }`}
          >
            {t("admin_other")}
          </button>
          <button
            onClick={() => setActiveTab("mainInfo")}
            className={`rounded-lg p-3 text-sm font-bold ${
              activeTab === "mainInfo"
                ? "bg-violet-400 text-white"
                : "bg-white text-gray-500 dark:bg-slate-700 dark:text-gray-300"
            }`}
          >
            {t("admin_main_info")}
          </button>
        </div>

        {activeTab === "other" && (
          <>
            <div className="w-full flex items-center justify-end ">
              <button
                onClick={() => {
                  handleAddNewToggle(true);
                }}
                className="sm:w-full rounded-lg p-3 text-white text-sm bg-violet-400 mx-5 sm:mx-0"
              >
                {t("admin_add_new_blog")}
              </button>
            </div>
            {addNewToggler && (
              <div className="bg-slate-100 dark:bg-slate-900">
                <div className="sm:px-0">
                  <form
                    onSubmit={(e) => {
                      handleAddNewToDb(e);
                    }}
                    encType="multipart/form-data"
                  >
                    <div className="w-full rounded-xl bg-white dark:bg-slate-700 p-5">
                      <div className="flex items-center justify-between flex-wrap gap-5">
                        <div className="flex items-center gap-5 sm:gap-3 ">
                          <div>
                            <h2
                              className="text-xl text-slate-400 font-bold dark:text-gray-400
                            sm:text-[16px] smd:text-[16px]"
                            >
                              {t("admin_add_new_blog")}
                            </h2>
                          </div>
                        </div>
                        <div className="flex gap-2 sm:w-full">
                          <button
                            type="submit"
                            className="rounded-lg p-3 text-white text-sm bg-violet-400 sm:w-full"
                          >
                            {t("admin_save")}
                          </button>
                          <button
                            onClick={() => {
                              handleAddNewToggle(false);
                            }}
                            className="rounded-lg p-3 text-white text-sm bg-red-400 w-10"
                          >
                            X
                          </button>
                        </div>
                      </div>
                      <FileInput name={t("admin_main_photo")} inputName={"img"} />
                      <div className="mt-5">
                        <MultipleFileInput
                          name={t("admin_inner_photos")}
                          inputName={"images"}
                        />
                      </div>
                      <MultyLangualTextInput
                        name={t("admin_title")}
                        geInputName={"titleGe"}
                        enInputName={"titleEn"}
                        inputSetter={handleAddNewData}
                      />
                      <MultyLangualTextArea
                        name={t("admin_short_description")}
                        geInputName={"smalTextGe"}
                        enInputName={"smalTextEn"}
                        inputSetter={handleAddNewData}
                      />
                      <MultyLangualTextArea
                        name={t("admin_long_description")}
                        geInputName={"textGe"}
                        enInputName={"textEn"}
                        inputSetter={handleAddNewData}
                      />
                    </div>
                  </form>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      <div className="w-full min-h-screen p-5">
        {activeTab === "other" && (
          <div className="grid grid-cols-1 gap-2">
            {blogData.map((item) => {
              return (
                <BlogCardAdmin
                  key={item.id}
                  item={item}
                  handleDelete={handleDeleteData}
                />
              );
            })}
          </div>
        )}

        {activeTab === "mainInfo" && (
          <div className="grid grid-cols-1 gap-3">
            {mainInfoData.length === 0 && (
              <p className="text-gray-500 text-sm">
                მთავარი ინფორმაცია არ არის დამატებული. გაუშვით SQL ბრძანება მონაცემთა ბაზაში.
              </p>
            )}
            {mainInfoData.map((item) => (
              <MainInfoCard
                key={item.id}
                item={item}
                onSave={handleFetchData}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const MainInfoCard = ({ item, onSave }) => {
  const { t } = useTranslation();
  const [isEditing, setIsEditing] = useState(false);
  const [newData, setNewData] = useState({});

  const handleNewData = (value, inputName) => {
    setNewData((prev) => ({ ...prev, [inputName]: value }));
  };

  const handleUpdate = () => {
    const formData = new FormData();
    formData.append("titleGe", newData.titleGe ?? item.titleGe ?? "");
    formData.append("titleEn", newData.titleEn ?? item.titleEn ?? "");
    formData.append("smalTextGe", newData.smalTextGe ?? item.smalTextGe ?? "");
    formData.append("smalTextEn", newData.smalTextEn ?? item.smalTextEn ?? "");
    formData.append("textGe", newData.textGe ?? item.textGe ?? "");
    formData.append("textEn", newData.textEn ?? item.textEn ?? "");
    formData.append("type", "mainInfo");
    formData.append("sort", item.sort ?? "");

    axiosAdmin
      .post(`/blog/${item.id}`, formData)
      .then(() => {
        onSave();
        successToast(t("admin_updated_success"));
        setIsEditing(false);
      })
      .catch(() => {
        errorToast(t("admin_error"));
      });
  };

  return (
    <div className="bg-white dark:bg-slate-700 rounded-xl p-5">
      <div className="flex items-center justify-between mb-3">
        <div>
          <span className="text-xs bg-teal-100 text-teal-700 px-2 py-1 rounded-full font-bold mr-2">
            #{item.sort}
          </span>
          <span className="text-[#777a83] font-bold text-[14px] dark:text-gray-200">
            {item.titleGe}
          </span>
        </div>
        <button
          onClick={() => setIsEditing(!isEditing)}
          className={`rounded-lg p-2 px-4 text-white text-sm ${
            isEditing ? "bg-red-400" : "bg-violet-400"
          }`}
        >
          {isEditing ? t("admin_close") : t("admin_edit")}
        </button>
      </div>

      {!isEditing && (
        <div className="text-gray-500 text-sm">
          <div dangerouslySetInnerHTML={{ __html: item.smalTextGe }} />
        </div>
      )}

      {isEditing && (
        <div>
          <MultyLangualTextInput
            name={t("admin_title")}
            geInputName={"titleGe"}
            enInputName={"titleEn"}
            inputSetter={handleNewData}
            value={item.titleGe}
            valueen={item.titleEn}
          />
          <MultyLangualRichText
            name={t("admin_short_description")}
            geInputName={"smalTextGe"}
            enInputName={"smalTextEn"}
            inputSetter={handleNewData}
            value={item.smalTextGe}
            valueen={item.smalTextEn}
          />
          <MultyLangualRichText
            name={t("admin_long_description")}
            geInputName={"textGe"}
            enInputName={"textEn"}
            inputSetter={handleNewData}
            value={item.textGe}
            valueen={item.textEn}
          />
          <button
            onClick={handleUpdate}
            className="rounded-lg p-3 text-white text-sm bg-violet-400 mt-5"
          >
            {t("admin_save")}
          </button>
        </div>
      )}
    </div>
  );
};

export default BlogsAdmin;
